import styles from "./Tabs.module.scss";
import { NavLink } from "react-router-dom";
import React from "react";
import QueryString from "qs";

export const Tabs: React.FC<{
  links: { path: string; title: string; params?: any; exact?: boolean }[];
}> = ({ links }) => (
  <nav className={styles.tabs}>
    {links.map(({ path, title, params, exact }, index) => (
      <NavLink
        key={index}
        className={styles.tab}
        to={{
          pathname: path,
          ...(params ? { search: QueryString.stringify(params) } : null)
        }}
        activeClassName={styles.active}
        exact={exact}
      >
        {title}
      </NavLink>
    ))}
  </nav>
);
